import React from 'react';

const LineIcon = ({ size = 16, height = "40", color = "white", ...props }) => {
  return (
    <svg
      width="2"
      height={height}
      viewBox="0 0 2 40"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.75"
        y1="0.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LineIcon;
